// @flow

import {
  getSolWrapper,
  REQUEST_JOB_DETAILS,
  getJobDetailsMetadata,
  addJobDetailsMetadata
} from 'src/modules/solTracker';

import get from 'lodash/get';
import { GET_RESULTS_SUCCESS } from '../results/results';
import { JOB_DETAILS_PAGE_LOADED } from '../jobdetails/jobdetails';
import isFunction from 'lodash/isFunction';

const getSolMetadata = payload => get(payload, 'result.solMetadata');

const sol = getSolWrapper();

const createSolTrackingMiddleware = () => (store: *) => (next: *) => (
  action: *
) => {
  if (isFunction(action)) {
    return action(store.dispatch, store.getState);
  }

  if (!ENV.SERVER) {
    if (action.type === GET_RESULTS_SUCCESS) {
      sol.trackSearchEvent(getSolMetadata(action.payload));
      const jobs = get(action, 'payload.result.data');
      addJobDetailsMetadata(jobs);
    }

    if (action.type === JOB_DETAILS_PAGE_LOADED) {
      const searchRequestToken = get(
        store.getState(),
        'location.query.searchrequesttoken'
      );
      const jobId = get(action, 'payload.job.id');
      const solMeta = getJobDetailsMetadata({ jobId, searchRequestToken });
      sol.trackActivity(REQUEST_JOB_DETAILS, solMeta);
    }
  }

  return next(action);
};

export default createSolTrackingMiddleware;
